module.exports = __webpack_public_path__ + "img/hyj5.5c455dce.png";